import {
    memo,
    ReactElement,
    useCallback,
    useState,
    MouseEvent,
    ButtonHTMLAttributes
} from "react";
import LoadingSpinner from "./loading_spinner";
import { useNavigate } from "react-router-dom";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    title: any;
    myStyle?: string;
    onClick?: any;
    icon?: any;
    props?: any;
    loading?: boolean;
    link?:string;
    autoLoading?: boolean;
}

export function Button({ onClick, title, myStyle, icon, loading , link, autoLoading = true}: Props, props: any): ReactElement {
    const navigation = useNavigate();
    const [internalLoading, setInternalLoading] = useState<boolean>(false);

    const handleOnClick = useCallback(async (event: MouseEvent<HTMLButtonElement>) => {
        if (!onClick) return;
        try {
            const result = onClick(event);
            if (autoLoading && result && typeof result.then === "function") {
                setInternalLoading(true);
                await result;
            }
        } finally {
            if (autoLoading) setInternalLoading(false);
        }
    }, [onClick, autoLoading]);

    return (
        <button
            className={`button ${myStyle}`}
            onClick={link ? () => navigation(link) : handleOnClick}
            disabled={Boolean(loading || internalLoading)}
            {...props}
        >
            {(loading || internalLoading) ?
                <LoadingSpinner/>
                :
                <h3 className="button-text">
                    {icon ?
                       <>
                    {icon}  {" "}  
                       </>
                       :
                       null
                    }
                    {title}
                </h3>
            }
        </button>
    )
}

export default memo(Button);